import { FC } from 'react';
import { format } from 'date-fns';
import { useGetOrder } from '@/data';
import { useSearchParams } from 'next/navigation';
import { Order as OrderType } from '@/types';
import {
  AuthContainer,
  Button,
  CancelOrderButton,
  Heading,
  Icon,
  OrderDetail,
  Spinner,
  useAuth,
} from '@/components';
import { useFeaturedFlag } from '@/hooks';
interface IOrderProps {
  expandReorder?: boolean;
  goBack: () => void;
}

const Order: FC<IOrderProps> = ({ expandReorder = true, goBack }) => {
  const searchParams = useSearchParams();
  const { isAuth } = useAuth();
  const { allowCancelOrder } = useFeaturedFlag();

  const { data, loading, refetch } = useGetOrder({
    notifyOnNetworkStatusChange: true,
    skip: !isAuth || !searchParams?.get('orderId'),
    variables: {
      entity_id: searchParams?.get('orderId') as string,
    },
  });

  const order = data;

  const isTreezPayAndNotACH =
    order?.payment_details?.type === 'TREEZPAY' &&
    order?.payment_details?.treezpay_detail?.payment_method !== 'ACH';

  return (
    <section className="order-details" style={{ position: 'relative' }}>
      <AuthContainer>
        {!data || loading ? (
          <div className="account__auth-loading">
            <Spinner>Loading...</Spinner>
          </div>
        ) : (
          <section>
            <div className="order-details__header">
              <Button className="back_button" color="link" onClick={goBack}>
                <Icon name="left" />
                <span>Back to orders</span>
              </Button>
              <Heading className="order-details__heading" level={3}>
                Order No.{' '}
                {order?.treez_order_number
                  ? `#${order?.treez_order_number}`
                  : 'Not Assigned yet'}
              </Heading>
              <div className="order__num-order">
                <p>
                  <strong>Created at:</strong>{' '}
                  {format(new Date(order?.created_at), "PPPP 'at' h:mmaaa")}
                </p>

                {order?.delivery_details?.started_at && (
                  <p>
                    <strong>
                      {order.delivery_details.delivery
                        ? 'Delivery '
                        : 'Pickup '}
                      Started At:{' '}
                    </strong>
                    {format(
                      new Date(order.delivery_details.started_at),
                      " PPPP 'at' h:mmaaa",
                    )}
                  </p>
                )}

                {order?.delivery_details?.finished_at && (
                  <p>
                    <strong>
                      {order.delivery_details.delivery
                        ? 'Delivery '
                        : 'Pickup '}
                      Finished At:
                    </strong>
                    {format(
                      new Date(order.delivery_details.finished_at),
                      " PPPP 'at' h:mmaaa",
                    )}
                  </p>
                )}

                {order?.status !== 'DECLINED' &&
                  order?.status !== 'DELIVERED' &&
                  !isTreezPayAndNotACH &&
                  allowCancelOrder && (
                    <CancelOrderButton
                      callback={() => {
                        refetch();
                      }}
                      className="order__btn_cancel"
                      color="secondary"
                      entityId={order?.entity_id!}
                    />
                  )}
              </div>
            </div>
            <OrderDetail
              expandReorder={expandReorder}
              order={order as OrderType}
            />
          </section>
        )}
      </AuthContainer>
    </section>
  );
};

export { Order };
